module.exports = __webpack_public_path__ + "img/Services.0ba55257.svg";